import Marquee from "react-fast-marquee";

const WORDS = [
  "Clinical Efficacy",
  "Pure Formulations",
  "Doctor Trusted",
  "Rigorous Science",
  "Dermatologist Grade",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="py-6 border-y border-ink/10 bg-stone">
      <Marquee speed={40} gradient={false}>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-4xl px-8 tracking-tight">{w}</span>
            <span className="text-derma text-2xl md:text-4xl">—</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
